






































import { Vue, Component } from "vue-property-decorator";

@Component
export default class CompanyStories extends Vue {
  get avatarSize(): number {
    switch (this.$vuetify.breakpoint.name) {
      case "xs":
      case "sm":
        return 80;
      case "md":
      case "lg":
        return 122;
      case "xl":
        return 132;
    }
  }

  colors = [
    "indigo",
    "warning",
    "pink darken-2",
    "red lighten-1",
    "deep-purple accent-4",
  ];

  slides = [
    // {
    //   text: this.$t(
    //     "Vi är verksamma inom ett relativt smalt IT-område och att få kontakt med kandidater som har både rätt kompetens och senioritet är väldigt tidskrävande. Med Gritify har vi fått en utmärkt kanal för att inte bara nå passiva kandidater utan även matcha med passiva kandidater vars önskemål om framtida karriärmöjligheter överensstämmer med det vi letar efter."
    //   ).toString(),
    //   name: "Melina Söderberg",
    //   title: this.$t("Consultant Manager på Asurgent").toString(),
    //   imageUrl: "/referenceStories/asurgent.png",
    // },
    {
      text: this.$t(
        "Som CTO har jag begränsat med tid att skriva annonser, administrera ansökningar eller läsa cv:n och personliga brev även om rekryteringsarbetet är mycket prioriterat. Gritify möjliggör för oss att arbeta helt databaserat och automatiserat vilket varit avgörande för oss."
      ).toString(),
      name: "Christoffer Jezek",
      title: this.$t("CTO på Sileon").toString(),
      imageUrl: "/referenceStories/sileon.png",
    },
    {
      text: this.$t(
        "Att löpande få stöd av Gritifys Customer Success har varit en stor tillgång för oss. Det är fenomenalt att få konkret rådgivning från seniora experter i hur vi ska uttrycka och positionera oss för bästa resultat. Deras förståelse för talangsmålgruppen har sparat oss mycket tid."
      ).toString(),
      name: "Martin Meldahl",
      title: this.$t("Technical Adviser på Nornorm").toString(),
      imageUrl: "/referenceStories/nornorm.png",
    },
    {
      text: this.$t(
        "Med Gritify var det lätt för oss att söka upp och kontakta 15 advokater med erfarenhet från både M&A och advokatbyrå. Inom en vecka hade vi 5 relevanta dialoger och på mindre än 30 dagar hade anställt vi en perfekt kandidat. Hela processen var otroligt smidig."
      ).toString(),
      name: "Edward af Sandeberg",
      title: this.$t("General Counsel på Serendipity").toString(),
      imageUrl: "/referenceStories/serendipity.png",
    },
  ];
}
